import { matchPath } from 'react-router-dom';
import { paths } from '../routes/paths';

export const isRecoveryRoute = (pathname: string): boolean => {
  return matchPath(paths.resetPassword, pathname) !== null;
};